const BUY_BUTTON_CLASS = 'js-product-buy-button'
const AUTH_BUTTON_CLASS = 'js-fc-auth-button'
const AUTH_GUARD_CLASS = 'js-fc-authguard'
const SELLING_PERIOD_DURING_CLASS = 'ruffruff-selling-periods__product-message__during-selling-period'
const SELLING_PERIOD_AFTER_CLASS = 'ruffruff-selling-periods__product-message__after-selling-period'
const SELLING_PERIOD_BEFORE_CLASS = 'ruffruff-selling-periods__product-message__before-selling-period'
const primaryLocale = 'ja'

const {
  FC_SITES,
  FC_AUTH_PAGE_URLS,
  FC_ALLOW_EXT_REFS,
  FC_BUTTON_LABEL,
  FC_DEFAULT_LINK_PW,
  FC_LINK_PW,
  isPrimaryLocale,
  locale
} = window.fcAuthSettings

const FC_PW = FC_LINK_PW || FC_DEFAULT_LINK_PW

const REFERER_URLS = [
  ...Object.values(FC_SITES).map(site => getOrigin(site.origin)),
  ...FC_ALLOW_EXT_REFS.map(url => getOrigin(url))
]

// セッションストレージに設定された言語にリダイレクト
const redirectToLocale = () => {
  const sessionLocale = sessionStorage.getItem('locale')
  if ((!sessionLocale || sessionLocale === "")) return

  if (sessionLocale === locale) return

  const { pathname, origin, search } = window.location
  const pathnames = pathname.split('/')

  if (isPrimaryLocale) {
    pathnames[1] = `${sessionLocale}/${pathnames[1]}`
  }
  else if (sessionLocale === primaryLocale) {
    pathnames.splice(1, 1)
  }
  else {
    pathnames[1] = sessionLocale
  }

  const newPathname = pathnames.join('/')

  const redirectUrl = `${origin}${newPathname}${search}`

  // セッションストレージをリセット
  sessionStorage.removeItem('locale')

  window.location.href = redirectUrl
}

// ファンクラブ経由どうかを判定する関数（参照元URLとクエリパラメータのパスワードで判定）
function isFanclubReferer() {
  // セッションストレージの認証ステータスを確認する
  const sessionLinkPass = sessionStorage.getItem('fanclub_auth_pw')
  if (sessionLinkPass === FC_PW) {
    return true
  }

  const urlParams = new URLSearchParams(window.location.search)
  const password = urlParams.get('link_pw')
  const referrer = getOrigin(document.referrer)

  // パスワードが一致し、参照元URLが指定されたURLと一致する場合
  if (REFERER_URLS.includes(referrer) && password === FC_PW) {
    // セッションストレージに認証ステータスを保存
    sessionStorage.setItem('fanclub_auth_pw', password)
    return true
  }

  if (REFERER_URLS.includes(sessionStorage.getItem('fanclub_auth_referrer_history', referrer)) && sessionStorage.getItem('fanclub_auth_pw_history') === FC_PW) {
    // セッションストレージに認証ステータスを保存`  
    sessionStorage.setItem('fanclub_auth_pw', password)
    return true
  }

  if (password && referrer && REFERER_URLS.includes(referrer)) {
    // セッションストレージに認証ステータスを保存
    sessionStorage.setItem('fanclub_auth_pw_history', password)
    sessionStorage.setItem('fanclub_auth_referrer_history', referrer)
  }

  return false
}

isFanclubReferer()

function createAuthButton(authPageUrls) {
  return authPageUrls.map(authPageUrl => {
    const FC_SITE = FC_SITES.find(site => getOrigin(site.origin) === getOrigin(authPageUrl))
    const { redirectManual, name } = FC_SITE || {}

    const redirectAuthUrl = redirectManual
      ? `${redirectManual.loginUrl}?${redirectManual.redirectQueryName}=${encodeURIComponent(authPageUrl)}&lang=${locale}`
      : `${authPageUrl}`

    const authButton = document.createElement('a')
    authButton.href = redirectAuthUrl
    authButton.textContent = `${name}${FC_BUTTON_LABEL}`
    authButton.style.marginTop = '5px'
    authButton.classList.add(AUTH_BUTTON_CLASS)
    authButton.onclick = () => {
      sessionStorage.setItem('locale', locale)
    }
    return authButton
  })
}

function ensureAuthButtons(authButtons) {
  const buyButtons = document.querySelectorAll(`.${BUY_BUTTON_CLASS}:not(.${AUTH_BUTTON_CLASS})`)
  const { fcAuthPrivateBrowsingNotice } = window.variantStrings || {}
  
  Array.from(buyButtons).forEach((buyButton) => {
    const existingAuthButtons = buyButton.parentNode.querySelectorAll(`.${AUTH_BUTTON_CLASS}`)
    if (existingAuthButtons.length) return
    authButtons.forEach((authButton) => {
      const clonedButton = authButton.cloneNode(true)
      clonedButton.className = `${buyButton.className} ${AUTH_BUTTON_CLASS}`
      clonedButton.onclick = authButton.onclick
      clonedButton.style.display = 'none'
      buyButton.parentNode.appendChild(clonedButton)
    })
    
    if (fcAuthPrivateBrowsingNotice && !buyButton.parentNode.querySelector('.fc-auth-private-browsing-notice')) {
      const notice = document.createElement('p')
      notice.className = 'fc-auth-private-browsing-notice'
      notice.textContent = fcAuthPrivateBrowsingNotice
      buyButton.parentNode.appendChild(notice)
    }
  })
}

function canShowFanclubAuthBySellingPeriod() {
  const hasDuringSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_DURING_CLASS).length > 0
  const hasBeforeSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_BEFORE_CLASS).length > 0
  const hasAfterSellingPeriod = document.getElementsByClassName(SELLING_PERIOD_AFTER_CLASS).length > 0

  if (hasBeforeSellingPeriod || hasAfterSellingPeriod) return false
  if (hasDuringSellingPeriod) return true

  return true
}

function toggleButtonsByState({ available }) {
  const buyButtons = document.querySelectorAll(`.${BUY_BUTTON_CLASS}:not(.${AUTH_BUTTON_CLASS})`)
  const authButtons = document.getElementsByClassName(AUTH_BUTTON_CLASS)
  const noticeElements = document.getElementsByClassName('fc-auth-private-browsing-notice')
  const isAvailable = available ?? window.fcAuthSettings?.IS_AVAILABLE

  if (!canShowFanclubAuthBySellingPeriod()) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  if (isAvailable === false) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  const isAuthenticated = isFanclubReferer()
  if (isAuthenticated) {
    Array.from(authButtons).forEach((button) => (button.style.display = 'none'))
    Array.from(buyButtons).forEach((button) => (button.style.display = ''))
    Array.from(noticeElements).forEach((notice) => (notice.style.display = 'none'))
    return
  }

  Array.from(buyButtons).forEach((button) => (button.style.display = 'none'))
  Array.from(authButtons).forEach((button) => (button.style.display = ''))
  Array.from(noticeElements).forEach((notice) => (notice.style.display = ''))
}

function watchSellingPeriodState() {
  if (!document.body) return

  const hasSellingPeriodClass = (node) => {
    if (!(node instanceof Element)) return false

    if (
      node.classList.contains(SELLING_PERIOD_DURING_CLASS) ||
      node.classList.contains(SELLING_PERIOD_BEFORE_CLASS) ||
      node.classList.contains(SELLING_PERIOD_AFTER_CLASS)
    ) {
      return true
    }

    return !!node.querySelector(
      `.${SELLING_PERIOD_DURING_CLASS}, .${SELLING_PERIOD_BEFORE_CLASS}, .${SELLING_PERIOD_AFTER_CLASS}`
    )
  }

  const observer = new MutationObserver((mutations) => {
    const hasTargetMutation = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some((node) => hasSellingPeriodClass(node))
    )

    if (!hasTargetMutation) return
    toggleButtonsByState({ available: window.fcAuthSettings?.IS_AVAILABLE })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

function handleFanclubAuthGuard() {
  const authGuard = document.querySelector(`.${AUTH_GUARD_CLASS}`)
  if (!authGuard) return
  redirectToLocale()
  const authButtons = createAuthButton(FC_AUTH_PAGE_URLS || [])
  ensureAuthButtons(authButtons)
  toggleButtonsByState({ available: window.fcAuthSettings?.IS_AVAILABLE })
  watchSellingPeriodState()

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const available = event?.data?.variant?.available
      if (window.fcAuthSettings) {
        window.fcAuthSettings.IS_AVAILABLE = available
      }
      toggleButtonsByState({ available })
    })
  }
}

handleFanclubAuthGuard()


function getOrigin(url) {
  try {
    return new URL(url).origin
  } catch (e) {
    console.error('Invalid URL:', url)
    return ''
  }
}
